import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { SelfFixRoutes } from '@self-fix/util-models';
import {
  Observable,
  of,
  switchMap,
  catchError,
  tap,
  filter,
  take,
  mergeMap,
} from 'rxjs';
import { BYPASS_ROUTE_GUARD } from '@domgen/dgx-fe-common';
import { assistanceType, PlanClaimsStore } from '@self-fix/data-access';

export const assistanceGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const bypassRoute = inject(BYPASS_ROUTE_GUARD, { optional: true });
  const platformId = inject(PLATFORM_ID);

  if (bypassRoute || isPlatformServer(platformId)) {
    return of(true);
  }

  return getFromStoreOrAPI(route).pipe(
    switchMap(() => of(true)),
    catchError(() => of(false))
  );
};

const getFromStoreOrAPI = (route: ActivatedRouteSnapshot): Observable<any> => {
  const store: PlanClaimsStore = inject(PlanClaimsStore);
  const router = inject(Router);

  return store.assistance$.pipe(
    tap((assistance: assistanceType) => {
      if (assistance === 'None') {
        const planNumber = route.queryParamMap.get('planNumber');
        router.navigate([SelfFixRoutes.ApplianceDetails], {
          queryParams: { planNumber },
          queryParamsHandling: 'merge',
        });
      }
    }),
    filter((assistance: assistanceType) => assistance !== 'None'),
    take(1)
  );
};
